import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d28099c4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./css/index.less?vue&type=style&index=0&id=d28099c4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28099c4",
  null
  
)

export default component.exports